import type { ResearchContent } from "../types";
import { renderSectionHeader } from "./section-header";

export function renderResearch(research: ResearchContent): string {
  const rows = research.items
    .map(
      (r, i) => `
      <article class="research-item" data-reveal style="--i:${i}">
        <span class="research-area">${r.area}</span>
        <div class="research-body">
          <h3>${r.title}</h3>
          <p>${r.summary}</p>
        </div>
        <span class="research-status" data-status="${r.status}">${r.status}</span>
      </article>`,
    )
    .join("");

  return `
    <section class="section" id="${research.id}">
      ${renderSectionHeader(research.header)}
      <div class="research">${rows}</div>
    </section>`;
}
